import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  @Input() placeholder:string = '';
  @Input() type: 'text' | 'number' | 'password' = 'text';
  @Input() maxlength?: number;

  @Input() size: 'xs-small' | 's-small' | 'normal' = 'normal';
  @Input() customClass:string = '';

  @Input() onlyNumbers:boolean = false;

  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    if (this.onlyNumbers) {
      val = val.replace(/[^0-9]/g, '');
      input.value = val; 
    }

    this.value = val;
    this.valueChange.emit(val);
  }

  allowCtrlKeys(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey) {
      // permite Ctrl+C, Ctrl+V, Ctrl+A, Ctrl+X
      event.stopPropagation();
      return;
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
